import { useEffect } from 'react';
import { i18n } from '../services';

/** Langue UI stockée (Home / header / i18n). */
export function readStoredUiLocale(): 'fr' | 'en' {
    try {
        const stored = localStorage.getItem('currentLanguage');
        if (stored === 'fr' || stored?.startsWith('fr')) return 'fr';
        if (stored === 'en' || stored?.startsWith('en')) return 'en';
    } catch {
        /* ignore */
    }
    const lang = i18n.language || '';
    if (lang.startsWith('fr')) return 'fr';
    return 'en';
}

/**
 * Langue UI pour les pages publiques contributeur / lien répondeur.
 * La langue de la collecte prime ; sinon préférence utilisateur (localStorage / i18n).
 */
export function resolveContributorUiLocale(
    effectiveLocale: string | null | undefined,
): 'fr' | 'en' {
    if (effectiveLocale === 'fr' || effectiveLocale === 'en') {
        return effectiveLocale;
    }
    return readStoredUiLocale();
}

/**
 * Espace contributeur public : sync réactive vers {@link resolveContributorUiLocale}.
 * (Les pages owner authentifiées n'appellent plus de sync vers effective_locale.)
 */
export function useContributorUiLocaleSync(
    mountKey: string | undefined,
    effectiveLocale: string | null | undefined,
): void {
    useEffect(() => {
        if (!mountKey) return;

        const target = resolveContributorUiLocale(effectiveLocale);

        if (!i18n.language?.startsWith(target)) {
            void i18n.changeLanguage(target);
        }
    }, [mountKey, effectiveLocale]);
}
